import { IComponentController } from 'angular';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IPaginationClass } from '../../../../../core/services/pagination.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';

interface IPageMr2028 extends IComponentController {
    formulaireMpm: IFormulaire;
    mpmMultiOccurrence: IMultiOccurrence;
    mpmMultiOccurrenceOptions: IMultiOccurrenceOptions;
    formulairePee: IFormulaire;
    peeMultiOccurrence: IMultiOccurrence;
    peeMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Mr2028Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    Pagination: IPaginationClass,
    mr0224Route: IRoute,
    Menu: IMenuClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    MenuItemForage: IMenuItemForageClass) {
    const vm: IPageMr2028 = this;

    vm.$onInit = function $onInit() {

        vm.valeursEcran = ecranDetails.valeurs;
        vm.monoOccurrenceOptions = {
            fonctions: {
                importation: false
            },
            formulaire: new Formulaire('LBL_BLC_MPE', [
                new FormulaireItem('mpecleint', { largeur: 100, hidden: true }),
                new FormulaireItem('mpdcleint', { largeur: 100 }),
                new FormulaireItem('mpemsg', {
                    largeur: 100,
                    enableCount: true,
                }),
                new FormulaireItem('mpddoc', {
                    largeur: 100,
                    readonly: true,
                    default: vm.valeursEcran.mpddoc,
                    enableCount: true,
                })
            ])
        };

        // Paramètres
        vm.mpmMultiOccurrenceOptions = {
            bloc: 'mpm',
            fonctions: {
                importation: false
            },
            // Affichage des colonnes visibles
            colonnesVisibles: [
                { nom: 'mpvnum', largeur: 80 },
                { nom: 'mpvlib', largeur: 250 },
                { nom: 'mprvaldat', largeur: 175 },
                { nom: 'mprvalnum', largeur: 140 },
                { nom: 'mprvalvar', largeur: 250 }
            ],
            formulaire: new Formulaire([
                new FormulaireItem('mpvcleint', { largeur: 100 }),
                new FormulaireItem('mprvaldat', { largeur: 100 }),
                new FormulaireItem('mprvalnum', { largeur: 100 }),
                new FormulaireItem('mprvalvar', { largeur: 100 }),
                new FormulaireItem('mpdcleint', {
                    hidden: true,
                    readonly: true,
                    default: vm.valeursEcran.mpdcleint
                })
            ]),
        };

        // Paramètres
        vm.peeMultiOccurrenceOptions = {
            bloc: 'pee',
            fonctions: {
                importation: false
            },
            // Affichage des colonnes visibles
            colonnesVisibles: [
                { nom: 'eplnummat', largeur: 100 },
                { nom: 'eplnomprn', largeur: 250 },
                { nom: 'peedatexc', largeur: 250 }
            ],
            formulaire: new Formulaire([
                new FormulaireItem('demcleint', { largeur: 100 }),
                new FormulaireItem('peedatexc', { largeur: 100 })
            ]),
        };
    }
}
